 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import { downloadCSV } from "@opendash/core";
import { translate, translateSync } from "@opendash/i18n";
import { Parse } from "@opendash/plugin-parse";
import { message } from "antd";
import { parse, unparse as toCSV } from "papaparse";
import {
  Massnahme,
  MassnahmeBerechnung,

  MassnahmeNachweis,
  UnterKategorie,
} from "../types-generated";











export class ImportExportService {
  

   __init() {this.attributes = [
    "jahr",
    "faktor",
    "absatz",
    "absatz_kg",
    "adresse",
    "anteilBioerdgas",
    "anzahl",
    "brennstoffeinsatz",
    "defaultFaktor",
    "emissionsfaktor",
    "erzeugterStrom",
    "erzeugteWaerme",
    "fahrleistung",
    "foerdervolumen",
    "kommentar",
    "kundenanzahl",
    "kundengruppe",
    "menge",
    "nennleistung",
    "oekofondAufschlag",
    "oekofondEinnahmen",
    "personenkm",
  ]}

   __init2() {this.attributesOfTypeNumber = [
    "absatz",
    "absatz_kg",
    "anteilBioerdgas",
    "anzahl",
    "brennstoffeinsatz",
    "defaultFaktor",
    "emissionsfaktor",
    "erzeugterStrom",
    "erzeugteWaerme",
    "fahrleistung",
    "faktor",
    "foerdervolumen",
    "jahr",
    "kundenanzahl",
    "menge",
    "nennleistung",
    "oekofondAufschlag",
    "oekofondEinnahmen",
    "personenkm",
  ]}

   __init3() {this.attributesOfTypeArray = ["kundengruppe"]}

  constructor(app) {;ImportExportService.prototype.__init.call(this);ImportExportService.prototype.__init2.call(this);ImportExportService.prototype.__init3.call(this);
    this.app = app;
  }

   async test() {
    const csv = await this.export();

    await this.import(csv);
  }

   async import(csvWithMeta) {
    const hide = message.loading("Daten werden importiert...", 0);

    // Zähler für Erfolge und Fehler hinzufügen
    let successCount = 0;
    let errorCount = 0;

    try {
      await translate("klimazaehler:init");

      const tenant = (await this.app.getTenant()) ;

      const unterkategorien = await new Parse.Query(UnterKategorie)
        .include("kategorie")
        .limit(1000000)
        .find();

      const massnahmen = await new Parse.Query(Massnahme)
        .equalTo("tenant", tenant)
        .ascending("bezeichnung")
        .include("kategorie")
        .limit(2000000)
        .find();

      const massnahmenJahre = await new Parse.Query(MassnahmeBerechnung)
        .equalTo("tenant", tenant)
        .ascending("jahr")
        .include("massnahme")
        // @ts-ignore
        .include("massnahme.kategorie")
        .limit(2000000)
        .find();

      const csvRows = csvWithMeta.split("\r\n");
      // Remove meta information
      csvRows.splice(0, 2);
      const csv = csvRows.join("\r\n");

      const { data: rows } = await parse(csv, {
        header: true,
        delimiter: ";",
        transform: (value, key) => {
          if (this.attributesOfTypeNumber.includes(key)) {
            if (!value) {
              return null;
            }

            const number = parseFloat(value.replace(",", "."));

            if (Number.isNaN(number)) {
              return null;
            } else {
              return number;
            }
          }

          if (this.attributesOfTypeArray.includes(key)) {
            if (!value) {
              return [];
            }

            return value.split(", ");
          }

          if (!value) {
            return null;
          }

          return value;
        },
      });

      const grouped = {};

      for (const row of rows ) {
        if (!grouped[row["massnahme.id"]]) {
          // Validiertes Start-Datum
          let startDate;
          try {
            startDate = row["massnahme.startDatum"]
              ? new Date(row["massnahme.startDatum"])
              : new Date(); // Standardwert: aktuelles Datum

            if (isNaN(startDate.getTime())) {
              console.warn(
                "Ungültiges Startdatum:",
                row["massnahme.startDatum"]
              );
              startDate = new Date(); // Standardwert: aktuelles Datum bei ungültigem Datum
            }
          } catch (e) {
            console.warn("Fehler beim Parsen des Startdatums:", e);
            startDate = new Date(); // Standardwert: aktuelles Datum bei Fehler
          }

          // End-Datum kann leer sein (undefined)
          let endDate = undefined;
          if (row["massnahme.endDatum"]) {
            try {
              endDate = new Date(row["massnahme.endDatum"]);
              if (isNaN(endDate.getTime())) {
                console.warn("Ungültiges Enddatum:", row["massnahme.endDatum"]);
                endDate = undefined;
              }
            } catch (e) {
              console.warn("Fehler beim Parsen des Enddatums:", e);
              endDate = undefined;
            }
          }

          grouped[row["massnahme.id"]] = {
            id: row["massnahme.id"],
            bezeichnung: row["massnahme.bezeichnung"],
            startDatum: startDate,
            endDatum: endDate,
            kategorieId: row["massnahme.kategorie.id"],
            jahre: [],
          };
        }

        grouped[row["massnahme.id"]].jahre.push({
          id: row["id"],
          ...pick(row, this.attributes),
        });
      }

      for (const group of Object.values(grouped)) {
        try {
          // Prüfe, ob eine Bezeichnung vorhanden ist
          if (!group.bezeichnung) {
            console.warn(
              `Maßnahme mit ID ${group.id} hat keine Bezeichnung, setze Standardwert`
            );
            group.bezeichnung = `Maßnahme ${group.id || "neu"}`;
          }

          let massnahme = massnahmen.find((x) => x.id === group.id);

          if (!massnahme) {
            massnahme = new Massnahme();
            massnahme.set("tenant", tenant); // Wichtig: Tenant setzen
          }

          const kategorie = unterkategorien.find(
            (x) => x.id === group.kategorieId
          );

          if (kategorie) {
            massnahme.set("kategorie", kategorie);
          } else {
            console.log("Gruppe:", group);
            message.error(
              `Ungültiger Wert '${group.kategorieId}' in der Spalte 'massnahme.kategorie.id' für die Zeile mit 'massnahme.id' = '${group.id}'.`
            );
          }

          try {
            massnahme.set("bezeichnung", group.bezeichnung);
            massnahme.set("startDatum", group.startDatum);
            massnahme.set("endDatum", group.endDatum);
            await massnahme.save();
            successCount++;
          } catch (error) {
            errorCount++;
            console.error(
              `Fehler beim Speichern der Maßnahme ${group.id}:`,
              error
            );
            message.error(
              `Fehler beim Speichern von "${group.bezeichnung}": ${error.message}`
            );
          }

          for (const { id, ...data } of group.jahre) {
            let massnahmenJahr = massnahmenJahre.find((x) => x.id === id);

            if (!massnahmenJahr) {
              massnahmenJahr = new MassnahmeBerechnung();
              massnahmenJahr.set("tenant", tenant); // Tenant setzen
              massnahmenJahr.set("massnahme", massnahme); // Massnahme-Referenz setzen

              // Jahr ist ein Pflichtfeld
              if (data.jahr) {
                massnahmenJahr.set("jahr", data.jahr);
              } else {
                console.error("Jahr fehlt, setze aktuelles Jahr als Standard");
                massnahmenJahr.set("jahr", new Date().getFullYear());
              }
            }

            try {
              // Daten setzen und speichern
              Object.entries(data).forEach(([key, value]) => {
                if (value !== undefined && value !== null) {
                  massnahmenJahr.set(key, value);
                }
              });

              await massnahmenJahr.save();
              successCount++;
            } catch (error) {
              errorCount++;
              console.error(
                `Fehler beim Speichern des Jahres ${data.jahr}:`,
                error
              );
              message.error(
                `Fehler beim Speichern des Jahres ${data.jahr}: ${error.message}`
              );
            }
          }
        } catch (error) {
          errorCount++;
          console.error(
            `Fehler beim Verarbeiten der Gruppe ${group.id}:`,
            error
          );
        }
      }

      hide();

      // Differenzierte Meldung basierend auf Erfolg/Fehler-Verhältnis
      if (errorCount === 0) {
        message.success(`Import erfolgreich: Einträge importiert.`);
      } else {
        message.warning(
          `Import teilweise erfolgreich: ${successCount} Einträge importiert, ${errorCount} Fehler aufgetreten.`
        );
      }
    } catch (error) {
      hide();
      message.error("Daten konnten nicht importiert werden.");
      console.error(error);
    }
  }

  async export() {
    const hide = message.loading("Daten werden exportiert...", 0);
    try {
      await translate("klimazaehler:init");

      const tenant = (await this.app.getTenant()) ;

      const massnahmenJahre = await new Parse.Query(MassnahmeBerechnung)
        .equalTo("tenant", tenant)
        .ascending("jahr")
        .include("massnahme")
        // @ts-ignore
        .include("massnahme.kategorie")
        .limit(1000000)
        .find();

      const massnahmenNachweise = await new Parse.Query(MassnahmeNachweis)
        .equalTo("tenant", tenant)
        .limit(1000000)
        .find();

      const data = [];

      data.push(["ASEW.KLIMAZähler Export", "version", "1.1"]);

      data.push([
        "Kategorie: " +
          translateSync(
            `klimazaehler:classes.KlimaZaehler_UnterKategorie.fields.bezeichnung`
          ),
        "Maßnahme: " +
          translateSync(
            `klimazaehler:classes.KlimaZaehler_Massnahme.fields.bezeichnung`
          ),
        "Maßnahme: " +
          translateSync(
            `klimazaehler:classes.KlimaZaehler_Massnahme.fields.startDatum`
          ),
        "Maßnahme: " +
          translateSync(
            `klimazaehler:classes.KlimaZaehler_Massnahme.fields.endDatum`
          ),
        "Vermeidungsfaktor",
        "Einsparung in tCO₂",
        "Nachweis",
        ...this.attributes.map((key) =>
          translateSync(
            `klimazaehler:classes.KlimaZaehler_MassnahmeBerechnung.fields.${key}`
          )
        ),

        "id",
        "massnahme.id",
        "massnahme.kategorie.id",
      ]);

      data.push([
        "massnahme.kategorie.bezeichnung",
        "massnahme.bezeichnung",
        "massnahme.startDatum",
        "massnahme.endDatum",
        "factor",
        "saving",
        "prove",
        ...this.attributes,
        "id",
        "massnahme.id",
        "massnahme.kategorie.id",
      ]);

      for (const mj of massnahmenJahre) {
        const factorValue =
          mj.faktor || mj.massnahme.kategorie.faktoren[mj.jahr] || 0;

        // Formatiere den Faktor im deutschen Format ohne Tausendertrennzeichen
        const factor = new Intl.NumberFormat("de-DE", {
          useGrouping: false,
        }).format(factorValue);

        // Formatiere die Einsparung im deutschen Format ohne Tausendertrennzeichen
        const saving = new Intl.NumberFormat("de-DE", {
          useGrouping: false,
        }).format(this.app.getMeasureYearSaving(mj));

        const prove = !!massnahmenNachweise.find(
          (prove) =>
            prove.jahr === mj.jahr && prove.massnahme.id === mj.massnahme.id
        )
          ? "Ja"
          : "Nein";

        data.push([
          mj.massnahme.kategorie.bezeichnung,
          mj.massnahme.bezeichnung,
          mj.massnahme.startDatum.toJSON(),
          _optionalChain([mj, 'access', _ => _.massnahme, 'access', _2 => _2.endDatum, 'optionalAccess', _3 => _3.toJSON, 'call', _4 => _4()]) || "",
          factor,
          saving,
          prove,
          ...this.attributes.map((key) => {
            const value = mj.get(
              key 
            );

            if (this.attributesOfTypeNumber.includes(key)) {
              if (value === null || value === undefined) {
                return "";
              }

              // Stelle sicher, dass wir eine Zahl haben
              const numValue =
                typeof value === "number" ? value : Number(value);

              // Überprüfe, ob es eine gültige Zahl ist
              if (isNaN(numValue)) {
                return "";
              }

              // Formatiere die Zahl im deutschen Format OHNE Tausendertrennzeichen
              return new Intl.NumberFormat("de-DE", {
                useGrouping: false, // Deaktiviert Tausendertrennzeichen
              }).format(numValue);
            }

            if (
              this.attributesOfTypeArray.includes(key) &&
              Array.isArray(value)
            ) {
              return value.join(", ");
            }

            return _optionalChain([value, 'optionalAccess', _5 => _5.toString, 'call', _6 => _6()]) || "";
          }),

          mj.id,
          mj.massnahme.id,
          mj.massnahme.kategorie.id,
        ]);
      }

      const csv = toCSV(data, {
        delimiter: ";",
      });

      hide();
      message.success("Daten wurden exportiert");
      return csv;
    } catch (error) {
      hide();
      message.error("Daten konnten nicht exportiert werden.");
      console.error(error);
      return "";
    }
  }

   async downloadExport() {
    const csv = await this.export();

    const tenant = await this.app.getTenant();
    const tenantName = _optionalChain([tenant, 'optionalAccess', _7 => _7.get, 'call', _8 => _8("label")]);
    const tenantId = _optionalChain([tenant, 'optionalAccess', _9 => _9.id]);

    const fileName = `asew-klimazaehler-export-${tenantName}-${tenantId}.csv`;

    downloadCSV(fileName, csv);
  }

   async importFile() {
    try {
      const csv = await requestFile();
      await this.import(csv);
    } catch (error) {
      console.error(error);
    }
  }
}

function pick(obj, keys) {
  return Object.fromEntries(
    keys.filter((key) => key in obj).map((key) => [key, obj[key]])
  );
}

function requestFile() {
  return new Promise((resolve, reject) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "*.csv";
    input.onchange = (e) => {
      // you can use this method to get file and perform respective operations
      let files = Array.from(input.files);

      if (files[0]) {
        const reader = new FileReader();
        reader.onload = function () {
          resolve(reader.result );
        };

        reader.readAsText(files[0]);
      } else {
        reject(new Error("Es wurde keine Datei ausgewählt"));
      }
    };

    input.click();
  });
}
